import Logo from "@/assets/assurance_maladie_white.svg";
import ServiceLogo from "@/assets/service_trajet_sante_white.svg";
import { useTranslation } from "react-i18next";
import LogoTheTreep from "@/assets/logo_thetreep.svg";
import { Svg } from "@thetreep/ui";
import { getVersion } from "@services/version";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { routes } from "@routes";

export function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [version, setVersion] = useState("");

  async function fetchVersion() {
    const res = await getVersion();
    setVersion(res.version);
  }

  useEffect(() => {
    // oxlint-disable-next-line react-hooks/set-state-in-effect
    fetchVersion().catch((e) => console.warn("failed to fetch version", e));
  }, []);

  return (
    <div
      className={`relative flex-col  bg-[#2f384d]  px-5 py-6 lg:px-24 xl:px-32 xl:py-10 2xl:px-48`}
    >
      <div className="flex flex-col xl:flex-row xl:justify-between">
        <div className="flex items-center gap-4 ">
          <img className="w-[160px] xl:w-[175px]" src={Logo} />
          <div className="bg-white w-[1px] h-[50px] self-stretch"></div>
          <img className="w-[89px] xl:w-[130px]" src={ServiceLogo} />
        </div>
        <div className="bg-[#9CA8C8] h-[1px] my-6"></div>
        <div className="flex flex-col gap-4 xl:flex-row xl:gap-8 xl:items-center">
          <a
            className="text-white text-base cursor-pointer"
            onClick={() => navigate(routes.TERMS_AND_CONDITIONS)}
          >
            {t("footer.termsAndConditions")}
          </a>
          <div className="hidden xl:block bg-white h-[12px] w-[1px] "> </div>
          <a
            className="text-white text-base cursor-pointer"
            onClick={() => navigate(routes.LEGAL_NOTICE)}
          >
            {t("footer.legalNotice")}
          </a>
          <div className="hidden xl:block bg-white h-[12px] w-[1px] "> </div>

          <a
            className="text-white text-base cursor-pointer"
            onClick={() => navigate(routes.PRIVACY_POLICY)}
          >
            {t("footer.privacyPolicy")}
          </a>
        </div>
      </div>
      <div className="bg-[#9CA8C8] h-[1px] my-10 "> </div>
      <div className="flex items-center md:justify-center gap-2 text-white text-xs">
        <span className="ml-auto">{t("footer.poweredBy")} </span>
        <Svg src={LogoTheTreep} color="white" width="85px" />
        <span className="text-white text-base ml-auto">{version}</span>
      </div>
    </div>
  );
}
